import React from 'react';

/** Defers rendering its children for the specified amount of time (default 1 second) */
export const Deferred: React.FC<{
  forMs?: number;
  children?: React.ReactNode;
}> = ({forMs = 1000, children}) => {
  const [render, setRender] = React.useState(false);

  React.useEffect(() => {
    const timeout = setTimeout(() => setRender(true), forMs);

    return () => clearTimeout(timeout);
  }, []);

  return render ? <>{children}</> : null;
};
